import analytics from '../axios-analytics';
import { MockServiceApiParams, workspaceBaseApi } from './apiCommon';

export default {
  recordings: {
    getRecordingByServiceMock: (serviceMockId: number, params: MockServiceApiParams) => {
      return analytics.get(`${workspaceBaseApi}/recording/service-mock/${serviceMockId}`, { params: params });
    },
    deleteAnalyticById: (serviceMockId: number, analyticIds: any[], params: MockServiceApiParams) => {
      return analytics.patch(
        `${workspaceBaseApi}/recording/service-mock/${serviceMockId}`,
        { analyticIds: analyticIds },
        { params: params },
      );
    },
  },
  inspectionData: {
    getInspectionData: (requestId: number | string, params?: any) => {
      return analytics.get(`${workspaceBaseApi}/inspection-data/requests/${requestId}`, {
        params: params,
      });
    },
  },
};
